module.exports = __webpack_public_path__ + "static/img/200180.779858b1.png";